import { clientOnly } from '~/decorators'

import { singleton } from '~/decorators/dependency-container'

@singleton()
export default class SpecificationViewService {
  getSpecificationTableId(): string {
    return 'specification-table'
  }

  @clientOnly
  getSpecificationTableElement(): Element | null {
    return document.getElementById(this.getSpecificationTableId())
  }
}
